import $ from 'jquery';
import moment from 'moment';

const LOG_SNIPPET_LENGTH = 100

export class LogService {
    constructor(component) {
        this.component = component;
    }

    loadLogs(extractionId, batchId, logRequest) {
        return new Promise((resolve, reject) => {
            try {
                const url = "/api/v1/extractions/" + extractionId + "/batches/" + batchId + "/logs"
                $.ajax({
                url: url,
                type: 'POST',
                data: JSON.stringify(logRequest),
                contentType: 'application/json',
                success: (res) => {
                    let formattedLogs = []
                    res.logs.forEach(function (log) {
                        let outputSet = (log.output && log.output != "null")
                        let output = (outputSet ? log.output : log.description + " " + log.info)
                        formattedLogs.push({
                            id: log.id,
                            type: log.critical ? 'critical' : outputSet ? 'output' : 'retry',
                            output_snippet: output.substring(0, LOG_SNIPPET_LENGTH) + (output.length > LOG_SNIPPET_LENGTH ? "..." : ""),
                            created_at: moment(log.created_at).format('MMM Do YYYY, h:mm:ss a'),
                            job_received: log.job_specification,
                            output: output,
                            messageId: log.message_id
                        })
                    });
                    res.formatted_logs = formattedLogs
                    resolve(res);
                },
                error: (error) => {
                    reject(error);
                }
            });
            } catch (error) {
                reject(error);
            }
        });
    }

    retryCriticalJobs(extractionId, batchId) {
        return new Promise((resolve, reject) => {
            try {
                var url = "/api/v1/extractions/" + extractionId + "/batches/" + batchId + "/retry_critical_jobs"
                $.get(url, res => {
                    resolve(res);
                }).catch(error => {
                    reject(error);
                });
            } catch (error) {
                reject(error);
            }
        });
    }
}